<template>
  <b-dropdown-item
    :value="value"
    :separator="separator"
    :disabled="disabled"
    :has-link="hasLink"
    :paddingless="paddingless"
    :custom="custom"
    :aria-role="ariaRole"
    @click="onClick"
  >
    <slot />
  </b-dropdown-item>
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'DropdownItemView',
  emits: ['click'],
  props: {
    value: {
      type: [Object, String, Number, Boolean, Array],
      default: null
    },
    separator: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hasLink: {
      type: Boolean,
      default: false
    },
    paddingless: {
      type: Boolean,
      default: false
    },
    custom: {
      type: Boolean,
      default: false
    },
    ariaRole: {
      type: String
    }
  },
  methods: {
    onClick(...args) {
      this.$emit('click', ...args);
    }
  }
};
</script>
